<template>
  <v-btn
    class="shared-button"
    :class="{
      'shared-button-size-sm': size === 'sm',
      'shared-button-size-md': size === 'md',
      'shared-button-radius-8': borderRadius8,
    }"
    :color="color"
    :loading="loading"
    :disabled="disabled"
    :elevation="elevation"
    :height="height"
    :block="block"
    @click="$emit('handleClick')"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'AuthButton',

  props: {
    color: {
      type: String,
      required: false,
      default: 'button-primary-background-default'
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    elevation: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    borderRadius8: {
      type: Boolean,
      required: false,
      default: false
    },
    height: {
      type: Number,
      required: false,
      default: undefined
    },
    block: {
      type: Boolean,
      required: false,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
.shared-button {
  color: var(--v-button-primary-foreground-default-base, #FFF)!important;
  font-family: 'Roboto', sans-serif;
  text-transform: none;
  border-radius: 8px;
  letter-spacing: normal;
  width: 100%;
}

.shared-button-size-sm {
  height: 40px !important;
  padding: 8px 16px !important;
}

.shared-button-size-md {
  height: 48px !important;
  padding: 12px 32px !important;
}

.shared-button > .v-btn__content {
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 24px;
}
.shared-button-radius-8 {
  border-radius: 8px;
}
</style>
